module.exports = __webpack_public_path__ + "static/lady-gaga-x-terry-richardson-bc4a82fa1c744a728a8edc50a5e0772e.jpg";